// src/components/Home.js
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Autocomplete, Button, Collapse, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useReactToPrint } from 'react-to-print';
// import NumPad from 'react-numpad';
import TableTabs from '../Components/TableTabs';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import BeatLoader from "react-spinners/BeatLoader";
import CustomerDialog from '../Components/AddPetDialog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { toast } from 'react-toastify';

const TREATMENT_CHARGES_NAME = 'Treatment Charges';
const BILL_TABLE_DEFAULT_WIDTH = 33.333333;
const BILL_TABLE_MIN_WIDTH = 28;
const BILL_TABLE_MAX_WIDTH = 58;

const formatAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount.toFixed(2) : '0.00';
};

const getTreatmentLineTotal = (item) => {
  const qty = parseFloat(item?.qty) || 0;
  const price = parseFloat(item?.Price) || 0;
  return qty * price;
};

const getTreatmentItemsTotal = (items) => (
  items.reduce((sum, item) => sum + getTreatmentLineTotal(item), 0)
);

const getTreatmentItemKey = (item) => (
  item?.ItemID ?? item?.itemId ?? item?.name
);

function Billing() {

  const [isHovering, setIsHovering] = useState(false);
  const [bills, setBills] = useState([''])
  const [paymentMethod, setPaymentMethos] = useState('Cash')
  const [cash, setCash] = useState(0)
  const [open, setOpen] = useState(false);
  const [openDisc, setOpenDisc] = useState(false);
  const [discount, setDiscount] = useState(0)
  const [tempDisc, setTempDisc] = useState(0)
  const [invno, setInvNo] = useState()
  const [items, setItems] = useState([])
  const [total, setTotal] = useState(0)
  const [metaData, setMetaData] = useState({ user: JSON.parse(localStorage.getItem("paws"))?.username, Total: total, Discount: discount, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
  const [loading, setLoading] = useState(false)
  const [userDetails, setUserDetails] = useState([])
  const [treatmentItems, setTreatmentItems] = useState([]);
  const [treatmentListOpen, setTreatmentListOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [consumedUnits, setConsumedUnits] = useState('');

  const [animalData, setAnimalData] = useState([]);
  const [selectedPet, setSelectedPet] = useState(null);

  const [allItemsforBilling, setAllItemsForBilling] = useState([])

  const [loadingItems, setLoadingItems] = useState(true)
  const [billTableWidth, setBillTableWidth] = useState(BILL_TABLE_DEFAULT_WIDTH);
  const billingLayoutRef = useRef(null);
  const codeRef = useRef(null);
  const skipNextBarcodeFocusRef = useRef(false);


  // Returns

  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const [returnBillNo, setReturnBillNo] = useState('');
  const [returnBillDetails, setReturnBillDetails] = useState([]);
  const [returnLoading, setReturnLoading] = useState(false);


  const navigate = useNavigate();

  const handleBillTableResizeStart = (event) => {
    if (!billingLayoutRef.current) {
      return;
    }

    event.preventDefault();

    const layout = billingLayoutRef.current;
    const originalCursor = document.body.style.cursor;
    const originalUserSelect = document.body.style.userSelect;

    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';

    const updateBillTableWidth = (pointerEvent) => {
      const layoutRect = layout.getBoundingClientRect();
      const nextWidth = ((pointerEvent.clientX - layoutRect.left) / layoutRect.width) * 100;

      setBillTableWidth(Math.min(BILL_TABLE_MAX_WIDTH, Math.max(BILL_TABLE_MIN_WIDTH, nextWidth)));
    };

    const stopResize = () => {
      document.body.style.cursor = originalCursor;
      document.body.style.userSelect = originalUserSelect;
      document.removeEventListener('pointermove', updateBillTableWidth);
      document.removeEventListener('pointerup', stopResize);
      document.removeEventListener('pointercancel', stopResize);
    };

    updateBillTableWidth(event);
    document.addEventListener('pointermove', updateBillTableWidth);
    document.addEventListener('pointerup', stopResize);
    document.addEventListener('pointercancel', stopResize);
  };

  useEffect(() => {
    if (!localStorage.getItem("paws")) {
      setLoading(true)
      navigate("/Login")
    }
    else {
      setUserDetails(JSON.parse(localStorage.getItem("paws")))
      //console.log(JSON.parse(localStorage.getItem("paws")))
      setLoading(false)
    }
    codeRef.current.focus();


    const getAlBillableItems = () => {
      setLoadingItems(true)
      axios.get("https://serverfourpaws.ccsoftwares.com/Item/getItemDetailsforBilling").then(res => {
        setAllItemsForBilling(res.data)
        setLoadingItems(false)
      }).catch(e => {
        ////console.log(e)
      })
    }

    getAlBillableItems()
  }, [])


  const getMax = () => {
    setLoading(true)

    const shop = JSON.parse(localStorage.getItem("paws"))?.shop

    if (shop === 'Ratnapura') {

      axios.get('https://serverfourpaws.ccsoftwares.com/billing/getmaxshop1').then(res => {
        //console.log(res.data[0].inv_no)
        setInvNo(res.data[0].inv_no)
        setLoading(false)
      })
    }
    else if (shop === 'Kalawana') {
      axios.get('https://serverfourpaws.ccsoftwares.com/billing/getmaxshop2').then(res => {
        //console.log(res.data[0].inv_no)
        setInvNo(res.data[0].inv_no)
        setLoading(false)
      })


    }
    else if (shop === 'Pelmadulla') {
      axios.get('https://serverfourpaws.ccsoftwares.com/billing/getmaxshop3').then(res => {
        //console.log(res.data[0].inv_no)
        setInvNo(res.data[0].inv_no)
        setLoading(false)
      })


    }


  }

  const [returnBills, setReturnBills] = useState([''])

  const getBills = () => {
    setLoading(true)

    const shop = JSON.parse(localStorage.getItem("paws"))?.shop

    if (shop === 'Ratnapura') {

      axios.get('https://serverfourpaws.ccsoftwares.com/billing/getshop1Bills').then(res => {
        console.log(res.data)
        setReturnBills(res.data)


      })
    }
    else if (shop === 'Kalawana') {
      axios.get('https://serverfourpaws.ccsoftwares.com/billing/getshop2Bills').then(res => {
        //console.log(res.data[0].inv_no)
        setReturnBills(res.data)

      })


    }
    else if (shop === 'Pelmadulla') {
      axios.get('https://serverfourpaws.ccsoftwares.com/billing/getshop3Bills').then(res => {
        //console.log(res.data[0].inv_no)
        setReturnBills(res.data)

      })


    }


  }


  const handleOpen = () => {
    setOpen(true);
    getMax()
    // setCash(0)
  };
  const handleOpenDisc = () => {
    setOpenDisc(true);
  };
  const handleClose = () => setOpen(false);
  const handleCloseDisc = () => setOpenDisc(false);

  const plusBtn = () => {
    setBills([...bills, ''])
  }


  const handleClick = () => {
    setDialogOpen(true);
  };

  const styles = {
    mainContainer: {
      backgroundColor: '#F5F5F5',
      width: '100%',
      // display : 'flex',
      justifyContent: 'center',
      margin: 10,
    },
    RightContainer: {
      backgroundColor: 'white',
      // width : '60%',
      // width : '1050px',
      // height : '85vh',
      // padding : 10,
      // marginTop : -20,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      // marginLeft : 20
    },
    sidePanel: {
      // backgroundColor : 'yellow',
      // marginRight : -10
    },
    sidepnlBtn: {
      // boxShadow: '1px 1px 10px #1e1e1e'
      borderRadius: 10
      , display: 'flex'
      , flexDirection: 'column',
      alignItems: 'center'
    },
    BillBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      backgroundColor: isHovering ? 'white' : 'white',
      height: 50,
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10

    },
    PlusBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      width: 35,
      borderRadius: 10
    },
    deleteBtn: {
      width: 25,
      marginLeft: 20,

    },
    billTable: {
      backgroundColor: 'white',
      // width : '490px',
      height: '60vh',
      padding: 10,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      display: 'flex',
      flexDirection: 'column',
      borderTopLeftRadius: 0,
      justifyContent: 'space-between',
      overflow: 'auto',
      // marginLeft : 50,

    },
    paymentSelect: {
      width: '10wh',
      backgroundColor: 'white',
      padding: 10,
      boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      marginTop: 20

    },
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      // width: 400,
      bgcolor: 'background.paper',
      border: '0px solid #000',
      boxShadow: 24,
      p: 4,
    }



  }



  useEffect(() => {

    var Total = 0.00

    for (let i = 0; i < items.length; i++) {
      Total = Total + parseFloat(items[i].Price) * parseFloat(items[i].qty)
    }

    setTotal(Total)

    if (skipNextBarcodeFocusRef.current) {
      skipNextBarcodeFocusRef.current = false;
      return;
    }

    codeRef.current.focus();

  }, [items])

  useEffect(() => {
    setItems((prevItems) => {
      const nonTreatmentItems = prevItems.filter((item) => item.name !== TREATMENT_CHARGES_NAME);

      if (treatmentItems.length === 0) {
        return nonTreatmentItems;
      }

      const existingTreatmentItem = prevItems.find((item) => item.name === TREATMENT_CHARGES_NAME);
      const treatmentChargesItem = {
        ...(existingTreatmentItem || {}),
        name: TREATMENT_CHARGES_NAME,
        qty: 1,
        Price: formatAmount(getTreatmentItemsTotal(treatmentItems)),
      };

      if (existingTreatmentItem) {
        return prevItems.map((item) => (
          item.name === TREATMENT_CHARGES_NAME ? treatmentChargesItem : item
        ));
      }

      return [...nonTreatmentItems, treatmentChargesItem];
    });

    if (treatmentItems.length === 0) {
      setTreatmentListOpen(false);
    }
  }, [treatmentItems])


  // const addToBill = (e) => {
  //   //console.log(e)
  //   if (items.length > 0) {
  //     let found = false;

  //     items.forEach((item, i) => {
  //       if (e.name === item.name) {
  //         ////console.log(item.qty)
  //         item.qty += 1;
  //         found = true;
  //         const updateItem = [...items];
  //         setItems(updateItem);
  //       }
  //     });

  //     if (!found) {
  //       const updateItem = [...items, e];
  //       setItems(updateItem);
  //     }
  //   } else {
  //     const updateItem = [...items, e];
  //     setItems(updateItem);
  //   }

  //   codeRef.current.focus();

  // }


  const handleModalSubmit = () => {
    if (consumedUnits && parseFloat(consumedUnits) > 0) {
      const unitPrice = parseFloat(modalItem.Price);
      const units = parseFloat(consumedUnits);
      const totalPrice = unitPrice * units;

      // Add the real item to treatmentItems
      const realItem = {
        ...modalItem,
        lineId: `${Date.now()}-${Math.random()}`,
        qty: units,
        Price: formatAmount(unitPrice),
        totalPrice: formatAmount(totalPrice),
      };

      setTreatmentItems((prevTreatmentItems) => {
        const existingItemIndex = prevTreatmentItems.findIndex((item) => (
          getTreatmentItemKey(item) === getTreatmentItemKey(realItem)
        ));

        if (existingItemIndex === -1) {
          return [...prevTreatmentItems, realItem];
        }

        return prevTreatmentItems.map((item, itemIndex) => {
          if (itemIndex !== existingItemIndex) {
            return item;
          }

          const existingQty = parseFloat(item.qty) || 0;
          const existingUnitPrice = parseFloat(item.Price);
          const mergedItem = {
            ...item,
            qty: existingQty + units,
            Price: formatAmount(Number.isFinite(existingUnitPrice) ? existingUnitPrice : unitPrice),
          };

          return {
            ...mergedItem,
            totalPrice: formatAmount(getTreatmentLineTotal(mergedItem)),
          };
        });
      });
      setTreatmentListOpen(true);

      setShowModal(false);
      setModalItem(null);
      setConsumedUnits('');

      codeRef.current.focus();
    } else {
      alert('Please enter a valid number of units.');
    }
  };



  const addToBill = (e) => {
    //console.log(e);
    if (e.ItemCategoryID === 1 || e.ItemCategoryID === 2 || e.ItemCategoryID === 18) {
      setModalItem(e);
      setShowModal(true);

    } else {
      if (items.length > 0) {
        let found = false;

        items.forEach((item, i) => {
          if (e.name === item.name) {
            item.qty += 1;
            found = true;
            const updateItem = [...items];
            setItems(updateItem);
          }
        });

        if (!found) {
          const updateItem = [...items, { ...e, qty: 1 }];
          setItems(updateItem);
        }
      } else {
        const updateItem = [...items, { ...e, qty: 1 }];
        setItems(updateItem);
      }

      codeRef.current.focus();
    }
  };


  const resetBill = () => {

    items.forEach((item, i) => {
      ////console.log(item.qty)
      item.qty = 1;
      const updateItem = [...items];
      setItems(updateItem);
    });
    setIsHovering(false);
    setBills([''])
    setPaymentMethos('Cash')
    setCash(0)
    setOpen(false);
    setOpenDisc(false);
    setDiscount(0)
    setTempDisc(0)
    setInvNo()
    setItems([])
    setTreatmentItems([])
    setTreatmentListOpen(false)
    setTotal(0)
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(localStorage.getItem("paws"))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })

    codeRef.current.focus();
  }


  const printsRef = useRef()

  const handlePrint = useReactToPrint({
    content: () => printsRef.current
  })


  const currentTime = new Date();
  const hours = formatTwoDigits(currentTime.getHours());
  const minutes = formatTwoDigits(currentTime.getMinutes());
  const seconds = formatTwoDigits(currentTime.getSeconds());

  function formatTwoDigits(value) {
    return value < 10 ? `0${value}` : value;
  }


  const returns = async () => {
    try {
      await getBills(); // Waits for getBills to complete
      console.log(returnBills);
      setReturnModalOpen(true); // Executes after getBills is done
    } catch (error) {
      console.error("Error fetching bills:", error);
      // Handle the error as needed
    }
  };

  const handleReturnClose = () => {
    setReturnModalOpen(false);
    setReturnBillNo('');
    setReturnBillDetails(null);
    codeRef.current.focus();
  };

  const handleReturnSubmit = () => {
    if (!returnBillNo) {
      toast.error('Please enter a bill number.');
      return;
    }
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }
    axios.post(`https://serverfourpaws.ccsoftwares.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  };

  const getReturnDetails = () => {
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }
    axios.post(`https://serverfourpaws.ccsoftwares.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  }



  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = formatTwoDigits(currentDate.getMonth() + 1); // Months are zero-based, so we add 1
  const day = formatTwoDigits(currentDate.getDate());
  const hour = formatTwoDigits(currentDate.getHours());
  const minute = formatTwoDigits(currentDate.getMinutes());
  const second = formatTwoDigits(currentDate.getSeconds());

  // ////console.log(metaData)

  useEffect(() => {
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(localStorage.getItem("paws"))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
    // codeRef.current.focus();
  }, [bills, cash, discount, paymentMethod, total])

  const toPrint = () => {

    // Combine items and treatmentItems, excluding "Treatment Charges" from items
    const individualItems = items.filter(item => item.name !== TREATMENT_CHARGES_NAME);
    const allItems = individualItems.concat(treatmentItems);

    // //console.log("all items",allItems)
    // Create an array to hold the models
    const models = [];

    // Loop through allItems to create the model for each item
    allItems.forEach((e, i) => {
      const model = {
        invoice_no: `${year}${month}${day}${hour}FP${invno}`,
        cashier: JSON.parse(localStorage.getItem("paws"))?.username,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        product_name: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
        unit_price: parseFloat(e.Price) || parseFloat(e.totalPrice) || 0,
        gross_total: metaData.Total,
        discount: metaData.Discount,
        net_total: metaData.Total - metaData.Discount,
        paymentMethod: metaData.Method,
        cash_amount: metaData.Amount,
        Balance: metaData.Amount - (metaData.Total - metaData.Discount),
        Item_ID: e.ItemID, // Use e._id if available, otherwise e.ItemID
        product_category_id: e.ItemCategoryID,
        store: JSON.parse(localStorage.getItem("paws"))?.shop,
        stockid: e.stockId
      };

      // Add the model to the models array
      models.push(model);
    });

    // Now models is an array of item models
    // //console.log('Models:', models);

    // Create billingData with items as models array
    const billingData = {
      inv_no: `${year}${month}${day}${hour}FP${invno}`,
      username: JSON.parse(localStorage.getItem("paws"))?.username,
      inv_date: `${year}-${month}-${day}`,
      gross_total: metaData.Total,
      discount: metaData.Discount,
      net_total: metaData.Total - metaData.Discount,
      shop: JSON.parse(localStorage.getItem("paws"))?.shop,
      paymentMethod: metaData.Method,
      petid: selectedPet?.AnimalID || -1,
      items: models, // Include the models array here
    };

    // Log billingData to verify
    // //console.log('Billing Data:', billingData);

    // Now create stockUpdateData
    const stockUpdateItems = [];

    allItems.forEach((e, i) => {

      const stockItem = {
        itemId: e._id || e.ItemID, // Use e._id if available, otherwise e.ItemID
        itemCategoryId: e.ItemCategoryID,
        itemName: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
      };

      stockUpdateItems.push(stockItem);
    });

    const stockUpdateData = {
      items: stockUpdateItems,
    };

    // Log stockUpdateData to verify
    // //console.log('Stock Update Data:', stockUpdateData);

    if (billingData.shop === 'Ratnapura') {
      //console.log(billingData)
      axios.post('https://serverfourpaws.ccsoftwares.com/billing/CreateShop1Invoice', billingData).then((res) => {
        axios.post('https://serverfourpaws.ccsoftwares.com/stock/BillShop1Items', stockUpdateData).then((res) => {
        }).catch(e => {
          //console.log(e)
        })
      }).catch(e => {
        //console.log(e)
      })
    }


    else if (billingData.shop === 'Kalawana') {
      axios.post('https://serverfourpaws.ccsoftwares.com/billing/CreateShop2Invoice', billingData).then((res) => {
        axios.post('https://serverfourpaws.ccsoftwares.com/stock/BillShop2Items', stockUpdateData).then((res) => {
        }).catch(e => {
          //console.log(e)
        })
      }).catch(e => {
        //console.log(e)
      })



    }
    else if (billingData.shop === 'Pelmadulla') {
      axios.post('https://serverfourpaws.ccsoftwares.com/billing/CreateShop3Invoice', billingData).then((res) => {
        axios.post('https://serverfourpaws.ccsoftwares.com/stock/BillShop3Items', stockUpdateData).then((res) => {
        }).catch(e => {
          //console.log(e)
        })
      }).catch(e => {
        //console.log(e)
      })

    }

    handlePrint()
    resetBill()

  }


  const changeQtyMinus = (e) => {
    if (e.name === TREATMENT_CHARGES_NAME) {
      return;
    }

    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (e.name === item.name) {
          ////console.log(item.qty)
          item.qty -= 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem);
    }

  }
  const changeQtyPlus = (e) => {
    if (e.name === TREATMENT_CHARGES_NAME) {
      return;
    }

    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (e.name === item.name) {
          ////console.log(item.qty)
          item.qty += 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem);
    }

  }

  const updateTreatmentItemValue = (index, field, value) => {
    skipNextBarcodeFocusRef.current = true;

    setTreatmentItems((prevTreatmentItems) => (
      prevTreatmentItems.map((item, itemIndex) => {
        if (itemIndex !== index) {
          return item;
        }

        const updatedItem = {
          ...item,
          [field]: value,
        };

        return {
          ...updatedItem,
          totalPrice: formatAmount(getTreatmentLineTotal(updatedItem)),
        };
      })
    ));
  };

  const removeTreatmentItem = (index) => {
    setTreatmentItems((prevTreatmentItems) => {
      const updatedTreatmentItems = prevTreatmentItems.filter((_, itemIndex) => itemIndex !== index);
      const hasOtherItems = items.some((item) => item.name !== TREATMENT_CHARGES_NAME);

      if (updatedTreatmentItems.length === 0 && !hasOtherItems) {
        setDiscount(0);
      }

      return updatedTreatmentItems;
    });
    codeRef.current.focus();
  };

  const addDiscount = () => {
    setDiscount(parseInt(discount) + parseInt(tempDisc))
    handleCloseDisc()

  }

  const deleteItem = (e) => {
    if (e === TREATMENT_CHARGES_NAME) {
      setTreatmentItems([]);
      setTreatmentListOpen(false);
    }

    setItems((prevItems) => {
      const updatedItems = prevItems.filter(item => item.name !== e);

      if (updatedItems.length < 1) {
        setDiscount(0)
      }

      return updatedItems;
    })
    codeRef.current.focus();
  }

  useEffect(() => {
    getAllAnimalDetails();
  }, []);

  const getAllAnimalDetails = () => {
    axios.get('https://serverfourpaws.ccsoftwares.com/Pet/getAllPetDetails').then((res) => {
      if (res.data.length > 0) {
        setAnimalData(res.data);
      } else {
        setAnimalData([]);
        toast.error('No records to display!');
      }
    });
  };

  const makeReturn = (billDetails) => {

    console.log(billDetails);

    const shop = JSON.parse(localStorage.getItem("paws"))?.shop;

    if (shop === 'Ratnapura') {

      console.log(shop);
      axios.post('https://serverfourpaws.ccsoftwares.com/billing/return1', billDetails).then((res) => {
        toast.error('Return Successful');
        getReturnDetails()
        codeRef.current.focus();
      });
    } else if (shop === 'Kalawana') {
      axios.post('https://serverfourpaws.ccsoftwares.com/billing/return2', billDetails).then((res) => {
        toast.error('Return Successful');
        getReturnDetails()
        codeRef.current.focus();
      });

    } else if (shop === 'Pelmadulla') {
      axios.post('https://serverfourpaws.ccsoftwares.com/billing/return3', billDetails).then((res) => {
        toast.error('Return Successful');
        getReturnDetails()
        codeRef.current.focus();
      });

    }



  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      allItemsforBilling.map((e, i) => {
        //console.log("ItemId",e.ItemID)
        //console.log("codeRef.current.value",codeRef.current.value)
        if (parseInt(e.ItemID) === parseInt(codeRef.current.value)) {
          //console.log(e)
          const itemDetails = e;
          itemDetails.name = e.ItemName
          itemDetails.Price = e.sellingPrice
          addToBill(itemDetails)
          codeRef.current.value = "";
        }

      })

    }
  };


  const handleQtyChange = (index, newQty) => {
    // Ensure the newQty is within the bounds (1 to e.qty)
    const updatedQty = Math.min(Math.max(newQty, 1), returnBillDetails[index].qty);

    // Update the returnBillDetails array (use a copy of the array to trigger re-render)
    setReturnBillDetails(prevDetails => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        returnQty: updatedQty,  // Store the updated return quantity
      };
      return updatedDetails;
    });
  };



  return (
    <>
      <CustomerDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
      {modalItem && (
        <Modal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setModalItem(null);
            setConsumedUnits('');
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Enter Consumed Units
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Base Unit Price: {modalItem.Price} {' '}
              {modalItem.ItemCategoryID === 1 ? 'per ml' : modalItem.ItemCategoryID === 18 ? '' : 'per g'}
            </Typography>
            <TextField
              autoFocus
              label="Consumed Units"
              type="number"
              value={consumedUnits}
              onChange={(e) => setConsumedUnits(e.target.value)}
              fullWidth
              sx={{ mt: 2 }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleModalSubmit();
                }
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleModalSubmit}
                sx={{ mr: 1 }}
              >
                Submit
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setShowModal(false);
                  setModalItem(null);
                  setConsumedUnits('');
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
      )}
      <Box
        ref={billingLayoutRef}
        sx={{
          height: '100%',
          mt: 0,
          pt: '76px',
          fontFamily: 'Arial',
          display: { xs: 'block', md: 'flex' },
          justifyContent: 'center',
          flexDirection: 'row',
          alignItems: 'stretch',
          gap: { xs: 0, md: 2 },
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', md: `${billTableWidth}%` },
            minWidth: { xs: '100%', md: 360 },
            maxWidth: { xs: '100%', md: `${BILL_TABLE_MAX_WIDTH}%` },
            flex: { md: '0 0 auto' },
            position: { md: 'relative' },
          }}
        >
          <Paper style={{ backgroundColor: 'white', height: '100%', marginLeft: 10, paddingLeft: 10, paddingRight: 10, marginBottom: 10 }}>
            <Box display="flex" alignItems="center">
              {loadingItems ? <BeatLoader /> : null}
              <TextField
                id="standard-basic"
                label="Item-Code"
                variant="standard"
                onKeyPress={handleKeyPress}
                inputRef={codeRef}
                autoComplete="off"
                sx={{ flexGrow: 1, marginRight: 1 }}
              />
              <Autocomplete
                options={animalData}
                getOptionLabel={(option) =>
                  `${option.AnimalName} (${option.petCode})`
                }
                onChange={(event, newValue) => {
                  setSelectedPet(newValue);
                  // Additional logic if needed when a pet is selected
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Pet"
                    variant="standard"
                    sx={{ flexGrow: 1, marginRight: 1 }}
                  />
                )}
                sx={{ flexGrow: 1, marginRight: 1 }}
              />
              <Tooltip title="Add Pet">
                <IconButton onClick={handleClick}>
                  <AddCircleOutlineIcon sx={{ color: 'black' }} />
                </IconButton>
              </Tooltip>

              <Button
                variant="contained"
                style={{
                  backgroundColor: '#FF0000',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: 14
                }}
                onClick={returns} // Updated to open modal
              >
                RETURNS
              </Button>

            </Box>
            <Box xs={2} width={'100%'}>
              {/* bill */}
              <div style={styles.billTable}>
                <table width={'100%'}>
                  <tr style={{ backgroundColor: 'white', fontSize: 18 }} >
                    <th align='left'></th>
                    <th align='left'>Item</th>
                    <th align='center'>Qty</th>
                    <th align='center'>Price</th>
                    <th style={{ textAlign: 'center' }}>Total</th>
                  </tr>
                  <tr style={{ backgroundColor: 'White', fontSize: 18 }}>
                    <td align='center' colSpan={6}><hr></hr></td>
                  </tr>
                  {items.slice().reverse().map((e, i) => {
                    const isTreatmentCharge = e.name === TREATMENT_CHARGES_NAME;

                    return (
                      <React.Fragment key={e.name}>
                        <tr style={{ fontSize: 18, fontFamily: 'consolas' }}>
                          <td align='left'>{i + 1}).</td>
                          <td align='left' width={100} colSpan={5}>
                            {isTreatmentCharge && (
                              <IconButton
                                size="small"
                                onClick={() => setTreatmentListOpen((prev) => !prev)}
                                style={{ padding: 0, marginRight: 6 }}
                              >
                                {treatmentListOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                              </IconButton>
                            )}
                            {e.name}
                            {isTreatmentCharge && (
                              <span style={{ fontSize: 12, marginLeft: 8, color: '#555' }}>
                                ({treatmentItems.length} items)
                              </span>
                            )}
                          </td>
                        </tr>


                        <tr style={{ backgroundColor: 'white', borderBottom: isTreatmentCharge && treatmentListOpen ? '0px solid black' : '2px solid black' }}>
                          <td></td>
                          <td></td>
                          <td align='center' style={{ fontWeight: 'bold' }}>
                            {isTreatmentCharge ? (
                              <span>{e.qty}</span>
                            ) : (
                              <>
                                {e.qty > 1 ? <button onClick={() => { changeQtyMinus(e) }} style={{ borderRadius: 50, borderWidth: 0, height: 30, width: 30, fontWeight: 'bold', marginRight: 10, backgroundColor: '#000000', color: 'white', fontSize: 18 }}>-</button> : <><button style={{ borderRadius: 50, borderWidth: 0, height: 30, width: 30, fontWeight: 'bold', marginRight: 10, backgroundColor: '#000000', color: 'white', fontSize: 18 }}>-</button></>}{e.qty}<button onClick={() => { changeQtyPlus(e) }} style={{ borderRadius: 50, borderWidth: 0, height: 30, width: 30, fontWeight: 'bold', marginLeft: 10, fontSize: 18, backgroundColor: '#000000', color: 'white' }}>+</button>
                              </>
                            )}
                          </td>
                          <td align='center' style={{ fontWeight: 'bold' }}>{e.Price}</td>
                          <td align='Right' onClick={handleOpenDisc} style={{ fontWeight: 'bold' }}>{formatAmount(parseFloat(e.Price) * parseFloat(e.qty))}</td>
                          <td>
                            <img src={require('../Assests/delete.png')} alt='billImage' style={styles.deleteBtn} width={20} onClick={() => deleteItem(e.name)}></img>
                          </td>

                        </tr>
                        {isTreatmentCharge && (
                          <tr style={{ backgroundColor: 'white', borderBottom: '2px solid black' }}>
                            <td colSpan={6} style={{ padding: 0 }}>
                              <Collapse in={treatmentListOpen} timeout="auto" unmountOnExit>
                                <div style={{ padding: '8px 4px 10px 34px', backgroundColor: '#F7F7F7' }}>
                                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 75px 90px 95px 38px', gap: 8, alignItems: 'center', fontSize: 12, fontWeight: 'bold', color: '#555', marginBottom: 6 }}>
                                    <span>Item</span>
                                    <span style={{ textAlign: 'center' }}>Qty</span>
                                    <span style={{ textAlign: 'center' }}>Price</span>
                                    <span style={{ textAlign: 'right' }}>Total</span>
                                    <span></span>
                                  </div>
                                  {treatmentItems.map((treatmentItem, treatmentIndex) => (
                                    <div
                                      key={treatmentItem.lineId || `${treatmentItem.ItemID}-${treatmentIndex}`}
                                      style={{ display: 'grid', gridTemplateColumns: '1fr 75px 90px 95px 38px', gap: 8, alignItems: 'center', marginBottom: 6, fontFamily: 'Arial' }}
                                    >
                                      <span style={{ fontSize: 13, fontWeight: 'bold' }}>{treatmentItem.name}</span>
                                      <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        value={treatmentItem.qty}
                                        onChange={(event) => updateTreatmentItemValue(treatmentIndex, 'qty', event.target.value)}
                                        style={{ height: 28, width: '100%', textAlign: 'center', fontWeight: 'bold' }}
                                      />
                                      <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        value={treatmentItem.Price}
                                        onChange={(event) => updateTreatmentItemValue(treatmentIndex, 'Price', event.target.value)}
                                        style={{ height: 28, width: '100%', textAlign: 'center', fontWeight: 'bold' }}
                                      />
                                      <span style={{ fontSize: 13, fontWeight: 'bold', textAlign: 'right' }}>
                                        {formatAmount(getTreatmentLineTotal(treatmentItem))}
                                      </span>
                                      <img
                                        src={require('../Assests/delete.png')}
                                        alt='billImage'
                                        style={{ ...styles.deleteBtn, width: 20, marginLeft: 8 }}
                                        onClick={() => removeTreatmentItem(treatmentIndex)}
                                      ></img>
                                    </div>
                                  ))}
                                </div>
                              </Collapse>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    )
                  })}
                </table>
              </div>
              <div style={{ fontSize: 40, color: 'Black', fontWeight: 'bold', marginTop: 10 }}>
                <div>
                  Total  Rs.<label style={{ color: 'gray' }}>  {formatAmount(total)}</label><br></br>
                </div>
                {/* <div style={{ fontSize: 30, color: 'gray' }}>
            Discount Rs.<label style={{ color: 'gray' }}>  {discount}.00</label><br></br>
          </div> */}
              </div>
              <div >
                {total > 0 ? <>
                  <button style={{ width: '100%', fontSize: 30, height: 65, marginTop: 10, fontWeight: 'bold', backgroundColor: '#00B912', borderRadius: 5, borderWidth: 0, color: "white", display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={handleOpen}>
                    Pay Rs.{formatAmount(total - discount)}
                    <img src={require('../Assests/cash.png')} alt='billImage' style={{ width: 45, marginLeft: 10 }}></img>
                  </button></> : <>
                  <button style={{ width: '100%', fontSize: 30, height: 65, marginTop: 10, fontWeight: 'bold', backgroundColor: 'gray', borderRadius: 5, borderWidth: 0, color: "white" }}>
                    Pay Rs.{formatAmount(total - discount)}
                    <img src={require('../Assests/cash.png')} alt='billImage' style={{ width: 45, marginLeft: 10, marginTop: -10 }}></img>
                  </button></>}
              </div>
            </Box>
          </Paper>
          <Box
            role="separator"
            aria-orientation="vertical"
            title="Drag to resize bill table"
            onPointerDown={handleBillTableResizeStart}
            sx={{
              display: { xs: 'none', md: 'flex' },
              position: 'absolute',
              top: 0,
              right: -16,
              bottom: '10px',
              alignItems: 'center',
              justifyContent: 'center',
              width: 16,
              cursor: 'col-resize',
              touchAction: 'none',
              zIndex: 2,
              '&::before': {
                content: '""',
                width: 4,
                height: 72,
                borderRadius: 2,
                backgroundColor: '#C9C9C9',
              },
              '&:hover::before': {
                backgroundColor: '#02847A',
              },
            }}
          />
        </Box>
        <Box
          sx={{
            width: { xs: '100%', md: 'auto' },
            minWidth: { xs: '100%', md: 420 },
            flex: { md: '1 1 0' },
          }}
        >
          <Paper style={{ backgroundColor: 'white', height: '100%', marginRight: 10 }}>
            <TableTabs bill={addToBill} />
          </Paper>
        </Box>
      </Box>

      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles.style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Payment Methods
            </Typography>
            <div>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="paymentMethod"
                onChange={(e) => { setPaymentMethos(e.target.value) }}
                value={paymentMethod}
              >
                <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
                <FormControlLabel value="Card" control={<Radio />} label="Card" />
              </RadioGroup>
            </div>
            {paymentMethod === 'Cash' ? (
              <div
                style={{
                  margin: 10,
                  display: 'flex',
                  height: '35vh',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'flex-start',
                }}
              >
                <Typography
                  id="modal-modal-description"
                  style={{ fontSize: 35, color: 'green' }}
                >
                  Total : Rs.{formatAmount(total - discount)}
                </Typography>
                <Typography
                  id="modal-modal-description"
                  style={{
                    fontSize: 25,
                    color: cash - (total - discount) < 0 ? 'red' : 'blue',
                  }}
                >
                  {cash - (total - discount) < 0 ? (
                    <>Balance : -- --</>
                  ) : (
                    <>Balance : Rs. {formatAmount(cash - (total - discount))}</>
                  )}
                  <hr />
                </Typography>

                <TextField
                  id="standard-basic"
                  onChange={(e) => {
                    setCash(e.target.value);
                  }}
                  type="number"
                  autoComplete="off"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && cash - (total - discount) >= 0) {
                      toPrint();
                    }
                  }}
                />

                <div style={{ fontSize: 25, alignItems: 'center' }}></div>

                {loading && paymentMethod === 'Cash' ? (
                  <center>
                    <BeatLoader color="#28968E" />
                  </center>
                ) : (
                  <>
                    {cash - (total - discount) < 0 ? (
                      <Button
                        style={{
                          width: '100%',
                          height: 80,
                          fontSize: 30,
                          marginTop: 15,
                          fontWeight: 'bold',
                          backgroundColor: '#A7A7A7',
                          borderRadius: 5,
                          color: 'black',
                        }}
                        disabled
                        variant="contained"
                        startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                      >
                        PRINT
                      </Button>
                    ) : (
                      <Button
                        style={{
                          width: '100%',
                          height: 80,
                          fontSize: 30,
                          marginTop: 15,
                          fontWeight: 'bold',
                          backgroundColor: '#0029FF',
                          borderRadius: 5,
                          color: 'white',
                        }}
                        onClick={toPrint}
                        variant="contained"
                        startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                      >
                        PRINT
                      </Button>
                    )}
                  </>
                )}
              </div>
            ) : (
              <div
                style={{
                  margin: 10,
                  display: 'flex',
                  height: '20vh',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                }}
              >
                <Typography
                  id="modal-modal-description"
                  style={{ fontSize: 35, color: 'green' }}
                >
                  Total : Rs.{formatAmount(total - discount)}
                </Typography>

                {loading ? (
                  <center>
                    <BeatLoader color="#28968E" />
                  </center>
                ) : (
                  <Button
                    style={{
                      width: '100%',
                      height: 80,
                      fontSize: 30,
                      marginRight: 5,
                      fontWeight: 'bold',
                      backgroundColor: '#0029FF',
                      borderRadius: 5,
                      color: 'white',
                    }}
                    onClick={toPrint}
                    variant="contained"
                    startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                  >
                    PRINT
                  </Button>
                )}
              </div>
            )}



          </Box>
        </Modal>
      </div>



      <div>
        <Modal
          open={openDisc}
          onClose={handleCloseDisc}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles.style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Discount Amount :
            </Typography>
            <br></br>
            <br></br>

            <TextField
              id="standard-basic"
              label="Discount in Rs."
              variant="standard"
              onChange={(e) => setDiscount(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  addDiscount();
                }
              }}
              type="number"
              autoComplete="off"
            />
            <br></br>
            <br></br>

            <div style={{ fontSize: 20 }}>
              <br></br>
              <br></br>
              <Button variant="outlined" onClick={() => addDiscount()} style={{ width: 300 }}>
                Add Discount
              </Button>
            </div>
          </Box>

        </Modal>
        {/* Bill */}
        <div style={{ display: 'none', position: 'relative', zIndex: 1000, justifyContent: 'center', top: 0, jeft: 0, width: '100%', height: '100%', alignItems: 'center' }}>
          <table border={0} width={'300'} style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold' }} id='BillingDoc' ref={printsRef}>
            <tr>
              <td colSpan={4} align='center'>
                <img src={require('../Assests/black.png')} alt='' width={150} style={{ marginBottom: 0 }}></img>
              </td>
            </tr>
            {JSON.parse(localStorage.getItem("paws"))?.shop === "Ratnapura" ? (

              <tr>
                <td colSpan={4} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}><label style={{ fontSize: 20 }}>4Paws Animal Clinic & Surgery</label><br></br>No: 526/A ,<br></br>
                  Colombo road,
                  Ratnapura.<br></br>Tel. (076) 099 9899 </td>

              </tr>
            ) :
              JSON.parse(localStorage.getItem("paws"))?.shop === "Kalawana" ?
                (

                  <tr>
                    <td colSpan={4} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}><label style={{ fontSize: 20 }}>4Paws Animal Clinic & Surgery</label><br></br>DKW Filling Station ,<br></br>
                      Manana,
                      Kalawana.<br></br>Tel. (076) 199 9899 </td>

                  </tr>
                ) : (
                  <tr>
                    <td colSpan={4} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}><label style={{ fontSize: 20 }}>4Paws Animal Clinic & Surgery</label><br></br>No:26 ,<br></br>
                      Balangoda road,
                      Pelmadulla.<br></br>Tel. (076) 399 9899 </td>

                  </tr>

                )}

            <tr>
              <td colSpan={4} align='right'> ---------------------------------</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Cashier : {JSON.parse(localStorage.getItem("paws"))?.username}</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Date : {`${year}-${month}-${day}`}</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Invoice no : {`${year}${month}${day}${hour + 5}FP${invno}`}</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'> ---------------------------------</td>
            </tr>
            {/* <tr>
              <td > </td>
              <td > Item</td>
              <td > Qty</td>
              <td > Price</td>
              <td align='center'> Total</td>
            </tr> */}
            {items?.map((e, i) => (
              <>
                <tr>
                  <td align='right'>{i + 1}<>).</></td>
                  <td colSpan={3}>{e.name}</td>
                </tr>
                <tr style={{ backgroundColor: 'white' }}>
                  <td ></td>
                  <td align='right'>{e.qty}</td>
                  <td align='center' colSpan={1}>{e.Price}</td>
                  <td align='right'>{e.qty * e.Price}.00</td>
                </tr>
              </>
            ))}
            <tr>
              <td colSpan={4} align='right'> --------------------------------- </td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>Gross  Rs.{metaData?.Total}.00</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>Discount  Rs.({metaData?.Discount}.00)</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>--------------------------------- </td>
            </tr>
            <tr>
              <td colSpan={3} align='left' style={{ fontWeight: 'bold' }}>Total</td>
              <td colSpan={1} align='right' style={{ fontWeight: 'bold' }}>Rs.{metaData?.Total - metaData?.Discount}.00</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>==========</td>
            </tr>
            <tr>
              <td colSpan={3} align='left'>{metaData?.Method} </td>
              {metaData?.Method === 'Card' ? (<>
                <td colSpan={1} align='right'>Rs.{metaData?.Amount - metaData?.Discount}.00</td>
              </>) :
                <td colSpan={1} align='right'>Rs.{metaData?.Amount}.00</td>
              }
            </tr>
            <tr>
              <td colSpan={3} align='left'>Balance  </td>
              {metaData?.Method === 'Card' ? (<>
                <td colSpan={1} align='right'>Rs.00.00</td>
              </>) :
                <td colSpan={1} align='right'>Rs.{metaData?.Amount - (metaData?.Total - metaData?.Discount)}.00</td>
              }
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 10 }}><br></br></td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 15 }}>Sharing Love ❤️ with Our Care</td>
            </tr>
            <tr>
              <td colSpan={4} align='center'>---------------------------------</td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 13, fontWeight: 'bold' }}>Software by CC Software Solutions</td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 13, fontWeight: 'bold' }}>077 0832 340</td>
            </tr>
          </table>



        </div>
        {/* Return Model */}
        <Modal
          open={returnModalOpen}
          onClose={handleReturnClose}
          aria-labelledby="return-modal-title"
          aria-describedby="return-modal-description"
        >
          <Box sx={styles.style}>
            <Typography id="return-modal-title" variant="h6" component="h2">
              Return Bill Details for {JSON.parse(localStorage.getItem("paws"))?.shop}
            </Typography>

            <div>
              <Grid container spacing={1}>
                <Grid xs={12} md={12}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', margin: 20 }}>

                    <Autocomplete
                      options={returnBills} // Pass the entire array of bill objects
                      getOptionLabel={(option) => option.inv_no || ''} // Extract 'inv_no' for display
                      value={
                        returnBills.find((bill) => bill.inv_no === returnBillNo) || returnBillNo || ''
                      } // Set the value to the selected bill object or the entered string
                      onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                          // User typed a bill number
                          setReturnBillNo(newValue);
                        } else if (newValue && newValue.inv_no) {
                          // User selected a bill from the dropdown
                          setReturnBillNo(newValue.inv_no);
                        } else {
                          // Handle cases like clearing the input
                          setReturnBillNo('');
                        }
                      }}
                      freeSolo // Allow users to enter values not present in the list
                      renderOption={(props, option) => (
                        <li {...props} key={option.inv_no}>
                          {option.inv_no}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Enter Bill Number"
                          variant="standard"
                          fullWidth
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              handleReturnSubmit();
                            }
                          }}
                        />
                      )}
                      noOptionsText="No matching bill numbers"
                      style={{ width: 300 }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleReturnSubmit}

                      style={{ marginLeft: 20, fontSize: 15 }}
                    >
                      Search
                    </Button>
                  </div>
                  <hr></hr>

                  <Grid xs={12} md={12}>
                    <div>
                      {/* Display the bill details */}
                      <TableContainer
                        component={Paper}
                        style={{
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                          height: 400, // Set the maximum height for the container
                          overflowY: 'auto',  // Enable vertical scrolling
                        }}
                      >
                        <Table stickyHeader style={{ minWidth: 650 }} >
                          <TableHead>
                            <TableRow style={{ backgroundColor: '#015C55' }}>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#015C55' }}>Invoice No</TableCell>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#015C55' }}>Item Name</TableCell>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#015C55' }}>Return Qty</TableCell>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#015C55' }}>Line Total</TableCell>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#015C55' }}>Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {returnBillDetails?.map((e, i) => (
                              <TableRow key={i} style={i % 2 === 0 ? { backgroundColor: '#f9f9f9' } : {}}>
                                <TableCell>{e.inv_no}</TableCell>
                                <TableCell>{e.item_name}</TableCell>

                                {/* Editable qty field */}
                                <TableCell>
                                  <input
                                    type="number"
                                    value={e.returnQty || e.qty}  // Default to e.qty if no returnQty is set
                                    min="1"
                                    max={e.qty}  // Prevent the return quantity from exceeding the total purchased quantity
                                    onChange={(event) => handleQtyChange(i, event.target.value)}
                                    style={{ width: '50px', textAlign: 'center', height: 30, fontSize: 20 }}
                                  />
                                </TableCell>

                                <TableCell>{e.total}</TableCell>

                                {e.total === 0.00 || e.billed_name === TREATMENT_CHARGES_NAME || e.qty === 0 ? (
                                  <TableCell><Button disabled>Not Applicable</Button></TableCell>
                                ) : (
                                  <TableCell><Button onClick={() => makeReturn(e)}>Return</Button></TableCell>
                                )}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {/* <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleReturnClose}
                            sx={{ mt: 2 }}
                          >
                            Close
                          </Button> */}
                    </div>
                  </Grid>



                </Grid>



              </Grid>
            </div>


            {returnLoading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <BeatLoader color="#28968E" />
              </Box>
            )}
          </Box>
        </Modal>

      </div>
    </>
  )
}

export default Billing
